<template>
  <div class="edm_container">
    <div ref="searchRef" class="header">
      <Logo />
      <Menu :is-active="isSearchInputOpen" />
      <div class="header_info">
        <!-- <FillButton @click="handleDirection">Listen to Your Feedback</FillButton> -->
        <!-- <User :name="name" :role-names="roleNames" /> -->
        <Search :is-active="isSearchInputOpen" @toggle="toggleSearchInputOpen" />
        <Notifity />
        <Avatar :name="name" :role-names="roleNames" :vp-role-str="vpRoleStr" :role-vo-list="roleVoList" />
      </div>
    </div>
    <div class="main_continer">
      <Feedback />
      <AiRobot />
      <router-view v-if="isRouterAlive" :key="$route.fullPath" />
    </div>
    <Popup />
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick, provide, watch } from 'vue';
import { useStore } from 'vuex';

import { getUserInfo } from '@/api/login';
import useClickOutside from '@/hooks/useClickOutside';
import FillButton from '@/components/button/FillButton.vue';

import Logo from './logo/index.vue';
import Menu from './menu/index.vue';
import Avatar from './avatar/index.vue';
import Notifity from './notifity/index.vue';
import Feedback from './feedback/index.vue';
import Popup from './popup/index.vue';
import Search from './search/index.vue';
import AiRobot from '@/components/AiRobot/index.vue';

const store = useStore();

const name = ref('');
const department = ref('');
const roleNames = ref([]);
const email = ref('');
const account = ref('');
const roles = ref([]);
const roleVoList = ref([]);
const vpRoleStr = ref('');
const init = () => {
  getUserInfo().then((res) => {
    name.value = res.name;
    department.value = res.department;
    email.value = res.email;
    account.value = res.account;
    roles.value = res.roles;
    roleNames.value = res.roleNames;
    roleVoList.value = res.roleVoList;
    vpRoleStr.value = res.vpRoleStr;
    const menuOptions = res.rbacPriList.map((item: any) => ({
      label: item.label,
      key: item.key,
      // name: item.children.length > 0 ? item.children[0].name : item.name,
      name: formatterSiderData(item),
      icon: item.icon,
      type: item.type,
      children: item.children,
    }));
    window.localStorage.setItem('userInfo', JSON.stringify(res || {}));
    window.localStorage.setItem('rbacPriList', JSON.stringify(res.rbacPriList));
    store.commit('user/SET_PRILIST', res.rbacPriList);
    store.commit('user/SET_MENUOPTIONS', menuOptions);
    store.commit('user/SET_PRIVILEGEBTNS', res.privilegeBtns);
    store.commit('user/SET_ROLES', res.roles);
    store.commit('user/SET_NAME', res.name);
    store.commit('user/SET_ACCOUNT', res.account);
    store.commit('user/SET_ROLENAMES', res.roleNames);
    store.commit('user/SET_USERINFO', res);
  });
};

type hander = (item: any) => string;

const formatterSiderData: hander = (item) => {
  if (item.children.length > 0) {
    if (item.children[0].type === 'router') {
      return item.children[0].name;
    } else {
      return formatterSiderData(item.children[0]);
    }
  } else {
    return item.name;
  }
};

init();

const isRouterAlive = ref(true);

const reloadFn = async () => {
  isRouterAlive.value = false;
  await nextTick();
  isRouterAlive.value = true;
};
const searchRef = ref<null | HTMLElement>(null);
const isClickOutside = useClickOutside(searchRef);
const isSearchInputOpen = ref(false);

const toggleSearchInputOpen = (flag: boolean) => {
  isSearchInputOpen.value = flag;
};

const handleDirection = () => {
  window.open('www.baidu.com', '__black');
};

watch(isClickOutside, () => {
  if (isSearchInputOpen.value && isClickOutside.value) {
    isSearchInputOpen.value = false;
  }
});

provide('reloadFn', reloadFn);
</script>

<style lang="scss" scoped>
.edm_container {
  width: 100%;
  min-height: 100vh;
  min-width: 1000px;
  max-width: 2200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.header {
  width: 100%;
  height: 56px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  .header_info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 24px;
    height: 100%;
  }
}

.main_continer {
  flex: 1;
  position: relative;
}
</style>
